import cacheSmartTaskDataAction from '../actions/cacheSmartTaskDataAction';
import { ClientItem } from 'owa-mail-store';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import { trace } from 'owa-trace';
import { SmartTaskSuggestion } from 'owa-mail-store';

const ENTITYID_KEY: string = '@EntityId';
const CONFIDENCE_SCORE_KEY: string = '@sourceConfidenceScore';

export default function parseSmartTaskProperty(
    item: ClientItem,
    extendedProperty: ExtendedPropertyType
): void {
    let validProperty: boolean = false;

    if (item) {
        if (extendedProperty) {
            try {
                validProperty = extractAndCacheSmartTaskFromProperty(item, extendedProperty);
            } catch (e) {
                trace.warn(
                    '[getSmartTasksForItem_parseSmartTaskProperty] Malformed property, cannot parse. Error: ' +
                        e.message
                );

                (e as { networkError?: boolean }).networkError = true;
                throw e;
            }
        } else {
            trace.info('[getSmartTasksForItem_parseSmartTaskProperty] No property found.');
        }

        // If the property is valid, extractAndCacheSmartTasksFromProperty will have cached the data.
        // Otherwise, cache that there is no valid property on the item.
        if (!validProperty) {
            cacheSmartTaskDataAction(item, false /* valid Property */);
        }
    } else {
        trace.info('[getSmartTasksForItem_parseSmartTaskProperty] No item found.');
    }
}

/**
 * @param item Item associated with smart task property.
 * @param parsedProperty Parsed property to extract data from.
 */
function extractAndCacheSmartTaskFromProperty(
    item: ClientItem,
    extendedProperty: ExtendedPropertyType
): boolean {
    const parsedProperty = JSON.parse(extendedProperty.Value);
    let validProperty: boolean = false;

    if (!extendedProperty) {
        trace.info(
            '[getSmartTaskForItem_parseSmartTaskProperty] No smart task extended property found.'
        );
        return validProperty;
    }

    const smartTasks: SmartTaskSuggestion[] = [];

    if (parsedProperty && parsedProperty.length > 0) {
        // Smart tasks
        const numSmartTasks = parsedProperty.length;
        for (let i = 0; i < numSmartTasks; i++) {
            const entity = parsedProperty[i];
            smartTasks.push({
                entityId: entity[ENTITYID_KEY],
                description: entity.description,
                confidenceScore: Number(entity[CONFIDENCE_SCORE_KEY]) * 100,
            } as SmartTaskSuggestion);
        }
    }

    // Initialize smart task data if we have extraction ID and expected number of smart replies.
    if (smartTasks.length > 0) {
        validProperty = true;
        cacheSmartTaskDataAction(item, validProperty, smartTasks);
    } else {
        trace.info(
            '[getSmartTasksForItem_extractAndCacheSmartTaskFromProperty] There are zero smart tasks for this item'
        );
    }

    return validProperty;
}
